import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import VinculoEmpregaticio from 'Interface/VinculosEmpregaticios';
import { useEditarVinculoEmpregaticioMutation } from 'View/Service/Default/VinculosEmpregaticios';

interface Props {
  dados: VinculoEmpregaticio;
  acoes?: boolean;
}

const Lista = ({ dados, acoes = true }: Props): React.ReactElement => {
  const toast = useToast();
  const [editarVinculo] = useEditarVinculoEmpregaticioMutation();

  const remover = async (): Promise<void> => {
    try {
      await editarVinculo({ id: dados.id, ativo: 0 }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4 flex-grow-1">
        <Link
          to={`/usuarios/editar/${dados.usuario_id}/vinculos/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.empresa?.nome_fantasia}
        </Link>
        <small className="text-muted fs-6 d-block">
          {dados.departamento?.nome}
        </small>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.funcao?.nome}
            <small className="text-muted fs-6 d-block">
              Função
            </small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.salario.moeda()}
            <small className="text-muted fs-6 d-block">
              Salário
            </small>
          </div>
        </div>
        <div className="ms-2 fs-5 text-end ms-5 d-flex gap-3 align-items-center">
          {!dados.status ? (
            <span className="badge bg-danger">
              Inativo
            </span>
          ) : (
            <span className="badge bg-success text-body">
              Ativo
            </span>
          )}
          {acoes && (
            <Botao
              icone="trash"
              tema="danger"
              confirmacao="Você tem certeza que deseja remover esse vinculo? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
